export const formatNumber = (number) => {
    return new Intl.NumberFormat('ro-RO').format(number)
}

export const processBackendErrors = (errorResponse, addNotification) => {
    if (errorResponse?.__handled) {
        return
    }

    const { errors, error } = errorResponse || {}

    if (error) {
        addNotification(error, 'error')
        return
    }

    if (errors && Object.keys(errors).length > 0) {
        Object.keys(errors).forEach((field) => {
            errors[field].forEach((errorMessage) => {
                addNotification(errorMessage, 'error')
            })
        })
    } else {
        addNotification('An error occurred. Please try again.', 'error')
    }
}

export const normalizePhone = phone =>
    (phone || '')
        .replace(/\D/g, '')
        .slice(-8)
